export default __webpack_public_path__ + "static/media/text3INFO.203bac1d.glb";